$(function(){

    var _animIndex={},_animStorage={};
    /*
     * imagesObj={
     *      "1":{path:"/gfx/place/fight/animation/cherry/1/anim.png","conf":{clips:9,height:361,width:567}},
     *      "2":{path:"/gfx/place/fight/animation/cherry/2/anim.png","conf":{clips:9,height:361,width:567}}
     * }
     */

    $.animCircleCurAnim=function(animIndex){
        if(typeof _animStorage[animIndex]!="undefined"){
            return _animStorage[animIndex].cur_anim;
        }
        return false;
    };
    $.fn.animCircle=function(options,imagesObj,timeHandler){
        var th=$(this);
        var settings=th.data("animCircle");
        var animIndex;

        function removeAnim(){
            delete _animIndex[animIndex];
            delete _animStorage[animIndex];
            th.data("animCircle",false);
        }
        function prepareNextScene(nextMili){
            timeHandler.setOne(animIndexArr.handler,function(){
                drawScene();
            },nextMili,function(){},function(){
                removeAnim();
            });
        }
        function drawScene(){

            if(typeof _animStorage[animIndex]!=="undefined"){
                var nextMili=_animStorage[animIndex].obj_anim.nextTime();
                if(nextMili>0){
                    prepareNextScene(nextMili);
                }
                _animStorage[animIndex].obj_anim.draw(ctx);
            }
            return true;
        }
        var methods={
            remove:function(){
                _animStorage[animIndex].obj_anim.remove();
            },
            clear:function(){
                _animStorage[animIndex].obj_anim.clear();
            },
            start:function(){
                _animStorage[animIndex].obj_anim.start();
            },
            addSteps:function(obj){
                _animStorage[animIndex].obj_anim.addAnim(obj);
            },
            setSteps:function(obj){
                _animStorage[animIndex].obj_anim.setAnim(obj);
            },
            takeAnimIndex:function(){
                return animIndex;
            },
            howlongRemain:function(){
                return _animStorage[animIndex].obj_anim.howlongRemain();
            },
            setTypeAva:function(arr){
                _animStorage[animIndex].obj_anim.setTypeAva(arr);
            },
            setClipsTime:function(arr){
                _animStorage[animIndex].obj_anim.setClipsTime(arr);
            }
        };



        /*
         * allImages={"1":{img:img,"conf":{clips:9,height:361,width:567}}}
         *
         *
         */
        function animObj(allImages){
            this.was_stoped=0;

            this.clip_cur=-1;
            this.clip_conf={};


            this.anim_types=allImages;
            this.next_time=50;

            this.queue_anim_arr=[];

            this.anim_storage=[];

            this.triggerVal=-1;
            this.miliStamp=0;

            this.typesAnimArr=[];
            this.const_clip_time=[35,75];
            this.anim_ava=[];
        }
        animObj.prototype={
            init:function(){
                this.setTypeTime();
            },
            start:function(){
                this.was_stoped=0;
                this.next_time=50;
                this.miliStamp=(new Date()).getTime();
                this.setNewAnim();
                drawScene();
            },
            addAnim:function(animObj){
                /*
                [
                {howlong:(bum.time-time_last),"end_val":i}
                {howlong:(bum.time-time_last),"end_val":i}
                {howlong:-1,"end_val":"end"}
                ]
                */
                var i;
                for(i in animObj){
                    this.anim_storage.push(copyObj(animObj[i]));
                }
//                this.anim_storage=copyArray(animObj);
            },
            setAnim:function(obj){
                this.anim_storage=copyArray(obj);
            },
            setTypeTime:function(){
                var i,bum,clips;
                for(i in this.anim_types){
                    bum=this.anim_types[i].conf;
                    if(bum!="end"){
                        clips=0;
                        if(i.indexOf("_")==-1){
                            clips=bum.clips;
                        }
                        else if(i.indexOf("_main")!=-1){
                            var main_key=i.replace("_main",""),k;
                            clips=bum.clips;
                            for(k=0;k<2;k++){
                                if(typeof this.anim_types[(main_key+"_"+k)]!="undefined"){
                                    clips+=this.anim_types[(main_key+"_"+k)].conf.clips;
                                }
                            }
                        }
                        this.anim_types[i].clips=clips;
                        this.anim_types[i].clips_real=bum.clips;
                        this.anim_types[i].howlong_min=clips*this.const_clip_time[0];
                    }
                }
            },
            setTypeAva:function(ava_arr){
                this.anim_ava=copyArray(ava_arr);
            },
            getTypeAva:function(howlong_max){
                var i,bum,arr=[];
                for(i in this.anim_types){
                    if(i!="end" && (this.anim_ava.length==0) || in_array(i,this.anim_ava)){
                        bum=this.anim_types[i];
                        if(bum.clips && bum.howlong_min<=howlong_max){
                            arr.push(i);
                        }
                    }
                }
                return arr;
            },
            nextTime:function(){
                return this.next_time;
            },
            draw:function(ctx,img){

                //clip_cur,clip_max
                if(this.was_stoped || this.next_time==0){
                    return 0;
                }
                var cur_conf=copyObj(this.clip_conf);
                var cur_clip=this.clip_cur;

                this.clip_cur++;
                if(this.clip_cur>=this.clip_conf.clips_real){
                    this.setNewAnim();
                }


                ctx.clearRect(0, 0, settings.width, settings.height);

                drawImageCrop(ctx,cur_conf.img,0,0,cur_conf.conf.width*cur_clip,0,cur_conf.conf.width,cur_conf.conf.height);





            },

            stopView:function(ctx){
                ctx.clearRect(0, 0, settings.width, settings.height);
                var conf;
                if(typeof this.anim_types["1"]!="undefined"){
                    conf=this.anim_types["1"];
                }
                else{
                    conf=this.anim_types["1_0"];
                }


                drawImageCrop(ctx,conf.img,0,0,0,0,conf.conf.width,conf.conf.height);
            },
            prepareQueue:function(){

                if(this.anim_storage.length==0){
                    this.next_time=0;
//                    if(this.triggerVal=="end"){
                        th.trigger("endStage",this.triggerVal);
//                    }
                    return false;
                }

                if(this.triggerVal!=-1){
                    th.trigger("endStage",this.triggerVal);
                }
                var conf=this.anim_storage.shift();
                this.triggerVal=conf.end_val;
                if(this.triggerVal=="end"){
                    th.trigger("beforeEnd");
                }
                if(this.triggerVal!="end"){
                    this.queue_anim_arr=[];
                    var time_old=this.miliStamp,time_cur=(new Date()).getTime();
                    this.miliStamp+=conf.howlong;
                    var howlong_dif=time_old-time_cur;
                    var howlong=conf.howlong+howlong_dif;


                    var ava_type=this.getTypeAva(howlong),type_add;

                    while(ava_type.length){
                        type_add=mt_rand(0,ava_type.length-1);
                        type_add=ava_type[type_add];
                        if(type_add.indexOf("_main")!=-1){
                            howlong-=this.addToQueue_main(type_add,howlong);
                        }
                        else{
                            howlong-=this.addToQueue(type_add,howlong);
                        }
                        ava_type=this.getTypeAva(howlong);
                    }
                }
                else{
                    this.queue_anim_arr=[{"next_time":50,"clip_type":"end"}];
                }
            },
            addToQueue:function(type,howlong_max){
                var conf_main=this.anim_types[type];
                var clip_time_max=Math.min(this.const_clip_time[1],Math.floor(howlong_max/conf_main.clips));
                var clip_time=mt_rand(this.const_clip_time[0],clip_time_max)
                this.queue_anim_arr.push({next_time:clip_time,clip_type:type});
                return (clip_time*conf_main.clips);
            },
            addToQueue_main:function(type,howlong_max){
                var main_key=type.replace("_main","");
                var conf_main=this.anim_types[type];
                var clip_max=Math.floor(howlong_max/this.const_clip_time[0]);
                var i,clip_border={};
                for(i=0;i<2;i++){
                    if(typeof this.anim_types[(main_key+"_"+i)]!="undefined"){
                        clip_border[i]=this.anim_types[(main_key+"_"+i)].clips_real;
                        clip_max-= clip_border[i];
                    }
                    else{
                        clip_border[i]=0;
                    }
                }

                var main_anim_max=Math.floor(clip_max/conf_main.clips);
                var main_anim=mt_rand(1,Math.min(7,main_anim_max));
                var clips_all=main_anim*conf_main.clips+clip_border[0]+clip_border[1];
                var clip_time_max=Math.min(this.const_clip_time[1],Math.floor(howlong_max/clips_all));
                var clip_time;
                var howlong=0;
                if(clip_border[0]){
                    clip_time=mt_rand(this.const_clip_time[0],clip_time_max);
                    this.queue_anim_arr.push({next_time:clip_time,clip_type:(main_key+"_0")});
                    howlong+=clip_time*clip_border[0];
                }
                for(i=0;i<main_anim;i++){
                    clip_time=mt_rand(this.const_clip_time[0],clip_time_max);
                    this.queue_anim_arr.push({next_time:clip_time,clip_type:type});
                    howlong+=clip_time*conf_main.clips;
                }
                if(clip_border[1]){
                    clip_time=mt_rand(this.const_clip_time[0],clip_time_max);
                    this.queue_anim_arr.push({next_time:clip_time,clip_type:(main_key+"_1")});
                    howlong+=clip_time*clip_border[1];
                }
                return howlong;
            },
            setNewAnim:function(){
                if(this.queue_anim_arr.length==0){
                    this.prepareQueue();
                }
                if(this.queue_anim_arr.length==0){
                    return false;
                }
                var arr=this.queue_anim_arr.shift();
                this.next_time=arr.next_time;
                this.clip_cur=0;
                this.clip_conf=this.anim_types[arr.clip_type];
                _animStorage[animIndex].cur_anim=arr.clip_type;
            },
            remove:function(){
                this.stop;
                removeAnim();
            },
            clear:function(){
                this.stop;
                this.queue_anim_arr=[];
                this.anim_storage=[];
            },
            stop:function(){
                this.was_stoped=1;
            },
            howlongRemain:function(){
                var howlong=0;
                var i;
                for(i in this.anim_storage){
                    howlong+=this.anim_storage[i].howlong;
                }
                return howlong;
            },
            setClipsTime:function(arr){
                this.const_clip_time=copyArray(arr);
            }

        };


        if(!settings){
            if(typeof options!="object"){
                return false;
            }
            settings=$.extend( {
                width:0,//{path:"gfx/place/fight/animation/cherry/1/anim.png",}
                height:0,
            }, options);

            function getNewAnimIndex(){
                var i=getNewObjectIndex(_animIndex,{});
                _animIndex[i]={handler:timeHandler.getNewIndex()};
                _animStorage[i]={"obj_anim":{},cur_anim:""};

                //
                return i;
            }
            function initAnim(animIndex,imagesReady){
                _animStorage[animIndex].obj_anim=new animObj(copyObj(imagesReady));
                _animStorage[animIndex].obj_anim.init();
            }
            if(typeof timeHandler=="undefined" || typeof timeHandler.getNewIndex=="undefined"){
                return false;//was not init
            }
            animIndex=getNewAnimIndex();

            var animIndexArr=_animIndex[animIndex];

            settings.animIndex=animIndex;
            var ctx=th[0];
            ctx=ctx.getContext("2d");
            function prepareImages(){
                var i,bum;
                var imageAll={};
                var width=0;
                var height=0;
                for(i in imagesObj){
                    bum=imagesObj[i];
                    imageAll[i]={};
                    imageAll[i].img=new Image();
                    imageAll[i].img.src=bum.path;
                    width=Math.max(width,intval(bum.conf.width));
                    height=Math.max(height,intval(bum.conf.height));
                    imageAll[i].conf=copyObj(bum.conf);
                }
                settings.width=width;
                settings.height=height;
                var obj={width:width,height:height};
                th.attr(obj).css(obj);
                return imageAll;
            }
            function preparePreloadArr(){
                var arr=[];
                var i;
                for(i in imagesObj){
                    arr.push(imagesObj[i].path);
                }
                return arr;
            }



            $("<div/>").one("myload",function(){
                initAnim(animIndex,prepareImages());

                _animStorage[animIndex].obj_anim.stopView(ctx);

                th.data("animCircle",settings);
                th.trigger("was_loaded");
            }).myLoad(preparePreloadArr());




        }
        else{
            var arg =Array.prototype.slice.call(arguments,1);
            animIndex=settings.animIndex;
            if(methods[options]){
                return methods[options].apply(this,arg);
            }

        }

        return true;

    };
});
